import React, { Component } from 'react'
import CloseIcon from '@material-ui/icons/Close';
import Auth from '../../utils/authenticate';
import Service from '../../config/networkutils';
import ProjectStaffLocationView from './ProjectStaffLocationView';
import { getDataIsdeletedFalse, getPrimaryColor } from '../Helper/CommonThings';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import SearchIcon from '@material-ui/icons/Search';
import { AppBar, Box, Button, CircularProgress, Dialog, IconButton, InputAdornment, Paper, Slide, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Grid } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const token = Auth.token()

class ProjectTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            data: [],
            selectedCRM: {},
            isLoading: true,
            selectedSector: [],
            selectedOwnerRegions: [],
            selectedOwnerDeliveryUnits: [],
            selectedDivisions: [],
            tableLoading: false,
            searchText: '',
            detailPanelRows: {},
        };
    }

    getCRMTableData() {
        Service.get('/api/crm/get_crm_data/?is_trashed=False&archive_reason=0', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {

                let data = res.data;
                let archive = []; let live = [];
                data.forEach(opportunity => {
                    if (opportunity.archive_reason > 0) {
                        archive.push(opportunity)
                    }
                    else live.push(opportunity)
                })
                this.setState({ data: live, archive: archive }, () => {
                    this.setState({ isLoading: false })
                })
            }).catch(error => {
                console.log(error)
                this.setState({ isLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    getDropdownData() {
        return new Promise((resolve, reject) => {
            Service.get('/api/roles/get_default_data/', {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    res.data.roles = getDataIsdeletedFalse(res.data.roles)
                    res.data.owner_region_sector = getDataIsdeletedFalse(res.data.owner_region_sector)
                    res.data.sub_sector = getDataIsdeletedFalse(res.data.sub_sector)
                    res.data.owner_delivery = getDataIsdeletedFalse(res.data.owner_delivery)
                    res.data.role_group = getDataIsdeletedFalse(res.data.role_group)
                    res.data.division = getDataIsdeletedFalse(res.data.division)
                    resolve(res.data)
                })
                .catch(error => reject(error))
        })
    }

    componentDidMount() {
        Promise.all([this.getDropdownData()])
            .then(res => {
                this.setState({
                    allSubSectors: res[0].sub_sector,
                    allOwnerRegions: res[0].owner_region_sector,
                    allOwnerDeliveryUnits: res[0].owner_delivery,
                    allDivisions: res[0].division,
                    isLoading: false
                })
            }).catch(e => {
                this.props.enqueueSnackbar('Something went wrong. Please try again later.', {
                    variant: 'error'
                });
            })
        //  allSubSectors: res[0].sub_sector,
        // this.getCRMTableData()
    }

    getReport() {
        this.setState({ tableLoading: true })
        let url = '/api/crm/get_crm_data/?is_trashed=False&archive_reason=0'
        if (this.state.selectedSector.length > 0) {
            url += `&sector=${this.state.selectedSector.map(sector => sector.id).join(',')}`
        }
        if (this.state.selectedOwnerRegions.length > 0) {
            url += `&region=${this.state.selectedOwnerRegions.map(region => region.id).join(',')}`
        }
        if (this.state.selectedOwnerDeliveryUnits.length > 0) {
            url += `&delivery=${this.state.selectedOwnerDeliveryUnits.map(delivery => delivery.id).join(',')}`
        }
        if (this.state.selectedDivisions.length > 0) {
            url += `&division=${this.state.selectedDivisions.map(division => division.id).join(',')}`
        }
        Service.get(url, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({ data: res.data, tableLoading: false })

            }).catch(error => {
                console.log(error)
                this.setState({ tableLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    toggleDetailPanelRow = (rowId) => {
        this.setState((prevState) => ({
            detailPanelRows: {
                ...prevState.detailPanelRows,
                [rowId]: !prevState.detailPanelRows[rowId]
            }
        }))
    }

    render() {
        const filteredTableData = (this.state.data || []).filter((row) => {
            const crmName = row?.name || ''
            const matchesSearch = crmName.toLowerCase().includes((this.state.searchText || '').toLowerCase())
            return matchesSearch
        })

        return (
            <div>
                {this.state.isLoading ? <Box width='100%' display='flex' justifyContent='center' alignItems='center'><CircularProgress /></Box> :
                    <Grid container spacing={1} style={{ marginBottom: '20px' }} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                        <Grid item xs={2.5}>
                            <Autocomplete
                                multiple
                                id="checkboxes-tags-demo"
                                options={this.state.allSubSectors ? this.state.allSubSectors : []}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option.name}
                                getOptionSelected={(option, value) => option.id === value.id}
                                value={this.state.selectedSector}
                                style={{ width: '100%' }}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedSector: newValue });
                                }}
                                renderOption={(option, { selected }) => {
                                    const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;
                                    return (
                                        <>
                                            <SelectionIcon
                                                fontSize="small"
                                                style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                            />
                                            {option.name}
                                        </>
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Sector"
                                        placeholder="Sector"
                                        variant='outlined'
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2.5}>
                            <Autocomplete
                                multiple
                                id="checkboxes-tags-demo"
                                options={this.state.allOwnerRegions ? this.state.allOwnerRegions : []}
                                disableCloseOnSelect
                                value={this.state.selectedOwnerRegions}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedOwnerRegions: newValue });
                                }}
                                getOptionLabel={(option) => option.name}
                                getOptionSelected={(option, value) => option.id === value.id}
                                renderOption={(option, { selected }) => {
                                    const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                                    return (
                                        <>
                                            <SelectionIcon
                                                fontSize="small"
                                                style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                            />
                                            {option.name}
                                        </>
                                    );
                                }}
                                style={{ width: '100%' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Region"
                                        placeholder="Region"
                                        variant='outlined'
                                        sx={{
                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(0, 0, 0, 0.35) !important',
                                                borderWidth: '1px !important'
                                            },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(0, 0, 0, 0.6) !important'
                                            },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: `${getPrimaryColor()} !important`,
                                                borderWidth: '2px !important'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2.5}>
                            <Autocomplete
                                multiple
                                id="checkboxes-tags-demo"
                                options={this.state.allOwnerDeliveryUnits ? this.state.allOwnerDeliveryUnits : []}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option.name}
                                getOptionSelected={(option, value) => option.id === value.id}
                                value={this.state.selectedOwnerDeliveryUnits}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedOwnerDeliveryUnits: newValue });
                                }}
                                renderOption={(option, { selected }) => {
                                    const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                                    return (
                                        <>
                                            <SelectionIcon
                                                fontSize="small"
                                                style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                            />
                                            {option.name}
                                        </>
                                    );
                                }}
                                style={{ width: '100%' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Operations Lead"
                                        placeholder="Operations Lead"
                                        variant='outlined'
                                        sx={{
                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(0, 0, 0, 0.35) !important',
                                                borderWidth: '1px !important'
                                            },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(0, 0, 0, 0.6) !important'
                                            },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: `${getPrimaryColor()} !important`,
                                                borderWidth: '2px !important'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2.5}>
                            <Autocomplete
                                multiple
                                id="checkboxes-tags-demo"
                                options={this.state.allDivisions ? this.state.allDivisions : []}
                                disableCloseOnSelect
                                value={this.state.selectedDivisions}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedDivisions: newValue });
                                }}
                                getOptionLabel={(option) => option.name}
                                getOptionSelected={(option, value) => option.id === value.id}
                                renderOption={(option, { selected }) => {
                                    const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;
                                    return (
                                        <>
                                            <SelectionIcon
                                                fontSize="small"
                                                style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                            />
                                            {option.name}
                                        </>
                                    );
                                }}
                                style={{ width: '100%' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Division"
                                        placeholder="Division"
                                        variant='outlined'
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant="contained" size='small' color="primary" onClick={() => this.getReport()}> Get Report</Button>
                        </Grid>
                    </Grid>
                }

                {this.state.tableLoading ? <Box width='100%' display='flex' justifyContent='center' alignItems='center'><CircularProgress /></Box> :
                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={1}>
                                        <Box display='flex' flexDirection='row' alignItems='center' >
                                            <Box flexGrow={1}>
                                                <Typography variant='h6'>CRM's</Typography>
                                            </Box>
                                            <TextField
                                                size='small'
                                                placeholder='Search CRM'
                                                value={this.state.searchText}
                                                onChange={(e) => this.setState({ searchText: e.target.value })}
                                                variant='outlined'
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody
                                sx={{
                                    '& .MuiTableRow-root:last-child .MuiTableCell-root': {
                                        borderBottom: 'none'
                                    }
                                }}
                            >
                                {this.state.tableLoading ? (
                                    <TableRow>
                                        <TableCell colSpan={2} align='center'>
                                            <CircularProgress size={20} />
                                        </TableCell>
                                    </TableRow>
                                ) : filteredTableData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={2} align='center'>No records to display</TableCell>
                                    </TableRow>
                                ) : (
                                    filteredTableData.map((row) => {
                                        const rowKey = row.id || row.name
                                        return (
                                            <React.Fragment key={rowKey}>
                                                <TableRow hover onClick={() => this.setState({ selectedCRM: row, open: true })} style={{ cursor: 'pointer' }}>
                                                    <TableCell>{row.name}</TableCell>
                                                </TableRow>
                                            </React.Fragment>
                                        )
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }

                <Dialog fullScreen open={this.state.open} onClose={() => this.setState({ open: false })} TransitionComponent={Transition}>
                    <AppBar>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={() => this.setState({ open: false })} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6">
                                {this.state.selectedCRM.name}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Box p={2}>
                        <ProjectStaffLocationView crm={this.state.selectedCRM} />
                    </Box>
                </Dialog>
            </div>
        )
    }
}

export default ProjectTable
